import React, { useEffect, useRef, useState, useCallback } from "react"
import { FaPlay } from "react-icons/fa6"
import { useMongoUser } from "../context/mongoContext"
import { IoCheckmarkCircleSharp, IoClose } from "react-icons/io5"
import axios from "axios"
import { texts } from "../constants"


const useTgAds = ({ adFormat, onReward, onError }) => {
  const AdControllerRef = useRef(undefined);

  useEffect(() => {
    if (window.TGAdsWidget) {
      const widget = window.TGAdsWidget;
      AdControllerRef.current = new widget({
        wid: '5979cee4-6e30-4a87-a4d6-3f52072543ea',
        adFormat: adFormat,
      });
    }
  }, [adFormat]);

  return useCallback(() => {
    if (AdControllerRef.current) {
      try {
        const widget = AdControllerRef.current;
        widget.requestRewardedAd(adFormat);

        widget.on('noAdFound', () => {
          onError?.({
            error: true,
            done: false,
            state: 'load',
            description: 'No ad found',
          });
        });

        widget.on('adReceived', (adList) => {
          widget.redirectToAd(adList);
        });

        widget.on('adRedirected', (adList) => {
          onReward();
        });
      } catch (error) {
        onError?.(error);
      }
    } else {
      onError?.({
        error: true,
        done: false,
        state: 'load',
        description: 'TGAds script not loaded',
      });
    }
  }, [onReward, onError, adFormat]);
};

const WatchAdsGramTask = () => {
  const bonusAmount = 2000
  const {
    user,
    setUser,
    AdsGramWatchCount,
    setAdsGramWatchCount,
    AdsGramCooldown,
    setAdsGramCooldown,
    adsGramRemainingTime,
    ADSGRAM_COOLDOWN_DURATION,
    SERVER_URL,
  } = useMongoUser()
  const [openAdsGramMenu, setOpenAdsGramMenu] = useState(false)
  const [congrats, setCongrats] = useState(false)
  const [isAdLoading, setIsAdLoading] = useState(false)
  const [showAdAlert, setShowAdAlert] = useState(false)
  const [localAdsGramLimit, setLocalAdsGramLimit] = useState(user.adsGramLimit)

  useEffect(() => {
    setLocalAdsGramLimit(user.adsGramLimit)
  }, [user.adsGramLimit])

  const formatNumber = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ")
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ")
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M"
    }
  }

  const onReward = useCallback(async () => {
    try {
      const newAdsGramWatchCount = AdsGramWatchCount - 1
      const newAdsGramLimit = localAdsGramLimit - 1
      const shouldSetCooldown = newAdsGramLimit === 0

      const response = await axios.post(`${SERVER_URL}/api/update-adsgram-watch`, {
        telegramId: user.telegramId,
        AdsGrampointsAward: bonusAmount,
        AdsGramWatchCount: newAdsGramWatchCount,
        adsGramTimeStamp: new Date(),
        adsGramLimit: newAdsGramLimit,
        lastAdsGramWatch: shouldSetCooldown ? new Date().toISOString() : user.lastAdsGramWatch,
      }) 

      setUser((prevUser) => ({
        ...prevUser,
        balance: response.data.data.balance,
        AdsGramWatchCount: response.data.data.AdsGramWatchCount,
        lastAdsGramWatch: response.data.data.lastAdsGramWatch,
        adsGramLimit: response.data.data.adsGramLimit,
      }))

      setLocalAdsGramLimit(newAdsGramLimit)

      if (shouldSetCooldown) {
        setAdsGramCooldown(ADSGRAM_COOLDOWN_DURATION)
      }
      setAdsGramWatchCount(newAdsGramWatchCount)

      setOpenAdsGramMenu(false)
      setCongrats(true)
      setShowAdAlert(true)
      setTimeout(() => {
        setCongrats(false)
      }, 3000)
    } catch (error) {
      console.error("Error updating after ad watch:", error)
    } finally {
      setIsAdLoading(false)
    }
  }, [
    AdsGramWatchCount,
    user,
    setUser,
    setAdsGramCooldown,
    setAdsGramWatchCount,
    ADSGRAM_COOLDOWN_DURATION,
    SERVER_URL,
    localAdsGramLimit,
  ])

  const onError = useCallback((error) => {
    console.error("Error showing TgAds ad:", error)
    setIsAdLoading(false)
  }, [])

  const showAd = useTgAds({
    adFormat: 'push-like', //specify the format available push-like and interstitial
    onReward,
    onError,
  });

  const handleWatchAdsGram = async () => {
    if (localAdsGramLimit <= 0 || AdsGramCooldown > 0 || isAdLoading) return
    setIsAdLoading(true)
    await showAd()
  }

  const renderModalContent = () => (
    <div className="w-full bg-divider shadowtop rounded-tl-[40px] rounded-tr-[40px] relative flex flex-col ease-in duration-300 transition-all justify-center">
      <div className="w-full flex taskbg rounded-tl-[40px] rounded-tr-[40px] mt-[2px] justify-center relative flex-col items-center space-y-3 p-4 pt-20 pb-24">
        <button
          onClick={() => setOpenAdsGramMenu(false)}
          className="flex items-center justify-center h-[32px] w-[32px] rounded-full bg-[#383838] absolute right-6 top-4 text-center font-medium text-[16px]"
        >
          <IoClose size={20} className="text-[#9995a4]" />
        </button>

        <div className="">
          <FaPlay size={50} className="text-accent" />
        </div>

        <div className="w-full flex flex-col justify-center items-center">
          <h3 className="font-semibold text-[24px]">Watch Ads</h3>
          <p className="text-[14px] font-medium text-center pb-3">
            Watch Ads & get more rewards every 1 hour, you can perform the watch Ads task only 5 times daily
          </p>
        </div>

        {localAdsGramLimit <= 0 ? (
          <>
            <div className="w-full bg-cards rounded-[16px] py-6 relative px-4 flex flex-col justify-center items-center">
              <p className="text-[#e5e5e5] font-medium px-8 text-[14px] w-full text-center">
                Your next free Ad watch starts in
              </p>
              <span className="text-[34px] font-semibold">{adsGramRemainingTime}</span>
            </div>

            <div className="w-full flex justify-center items-center flex-col space-y-4 pt-1">
              <button
                onClick={() => setOpenAdsGramMenu(false)}
                className={`w-full bg-btn text-[#000] py-[18px] px-2 text-nowrap flex items-center justify-center gap-2 text-center rounded-[12px] font-semibold text-[17px]`}
              >
                Continue
              </button>
            </div>
          </>
        ) : (
          <div className="w-full flex justify-center items-center flex-col space-y-4">
            {AdsGramCooldown > 0 ? (
              <button
                className={`w-full bg-yellow-500 text-[#000] py-[18px] px-2 text-nowrap flex items-center justify-center gap-2 text-center rounded-[12px] font-semibold text-[17px]`}
              >
                Watch Ads again in {adsGramRemainingTime}
              </button>
            ) : (
              <button
                onClick={handleWatchAdsGram}
                disabled={isAdLoading || localAdsGramLimit <= 0 || AdsGramCooldown > 0}
                className={`w-full py-[18px] px-6 text-nowrap flex items-center justify-center gap-2 text-center rounded-[12px] font-semibold text-[17px] ${
                  localAdsGramLimit <= 0 || AdsGramCooldown > 0 ? "bg-[#383838] text-[#9995a4]" : "bg-btn"
                }`}
              >
                <FaPlay className={isAdLoading ? "animate-spin" : ""} />
                {isAdLoading
                  ? "Loading Ad..."
                  : localAdsGramLimit <= 0
                    ? "No watches remaining"
                    : `Watch Ad (${localAdsGramLimit} left)`} 
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )

  const AdAlert = () => (
    <>
      <div className="w-full absolute top-[50px] flex justify-center z-50 pointer-events-none select-none">
        {congrats ? <img src="/congrats.gif" alt="congrats" className="w-[80%]" /> : <></>}
      </div>

      <div
        className={`${
          showAdAlert === true ? "visible" : "invisible"
        } fixed top-[-12px] claimdiv bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#00000042] flex flex-col justify-center items-center px-4`}
      >
        <div
          className={`${
            showAdAlert === true ? "opacity-100 mt-0" : "opacity-0 mt-[100px]"
          } w-full bg-modal rounded-[16px] relative flex flex-col ease-in duration-300 transition-all justify-center p-8`}
        >
          <div className="w-full flex justify-center flex-col items-center space-y-3">
            <div className="w-full items-center justify-center flex flex-col space-y-2">
              <IoCheckmarkCircleSharp size={32} className="text-accent" />
              <p className="font-medium">Congratulations!</p>
            </div>
            <h3 className="font-medium text-[24px] text-[#ffffff] pt-2 pb-2">
              <span className="text-accent">+ {bonusAmount}</span> {texts.projectSymbol}
            </h3>
            <p className="pb-6 text-[#bfbfbf] text-[15px] w-full text-center">
              Keep watching ads daily! something huge is coming! Get more {texts.projectSymbol} now!
            </p>

            <div className="w-full flex justify-center">
              <button
                onClick={() => setShowAdAlert(false)}
                className="bg-btn text-[#000] w-fit py-[10px] px-6 flex items-center justify-center text-center rounded-[12px] font-medium text-[16px]"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )

  return (
    <>
      {showAdAlert && <AdAlert />}

      <div className="w-full bg-cards px-3 rounded-xl py-3 flex items-center justify-between space-x-1">
        <div className="w-12 pr-2">
          <div className="flex items-center justify-center bg-gray-900 h-11 w-11 rounded-full p-1">
            <FaPlay size={20} className="w-[20px] ml-[4px]" />
          </div>
        </div>
        <div className={`flex flex-1 h-full flex-col justify-center`}>
          <div className={`w-full flex flex-col justify-between h-full space-y-1`}>
            <h1 className={`text-base font-medium truncate`}>See Ads & earn</h1>
            <span className="flex text-gray-400 items-center text-sm">
              <span className="">
                +{formatNumber(bonusAmount)} {texts.projectSymbol} each ads
              </span>
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-1 justify-end">
          <button
            onClick={() => setOpenAdsGramMenu(true)}
            disabled={localAdsGramLimit <= 0 || AdsGramCooldown > 0}
            className={`bg-[#36373c] py-2 px-4 text-sm text-center font-semibold rounded-full ${
              localAdsGramLimit <= 0 || AdsGramCooldown > 0 ? "text-gray-500 cursor-not-allowed" : "text-white"
            }`}
          >
            {localAdsGramLimit <= 0 ? "No watches left" : AdsGramCooldown > 0 ? "Cooldown" : "Start"}
          </button>
        </div>
      </div>

      {/* ads modal */}
      <div
        className={`${openAdsGramMenu ? "flex" : "hidden"} fixed bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#303030c4] flex-col justify-end items-center`}
      >
        {renderModalContent()}
      </div>
    </>
  )
}

export default WatchAdsGramTask
